import { Outside } from '@cian/ui-kit';
import cn from 'classnames';
import React, { memo } from 'react';
import { useToggleState } from '../../hooks';
import * as styles from './FilterDropdown.css';
import { DropdownView } from './internal/components/DropdownView';
import { FilterButton } from './internal/components/FilterButton';
import { IFilterDropdownProps } from './types';

export const FilterDropdown = memo<IFilterDropdownProps>(function FilterDropdown(props) {
  const { onCheckboxChange, checkboxGroups, checkboxValues } = props;

  const [isDropdownVisible, toggleVisibility] = useToggleState();

  const label = checkboxGroups.getLabel(checkboxValues);

  const isPlaceholderLabel = label === checkboxGroups.label;

  return (
    <Outside onOutside={toggleVisibility} active={isDropdownVisible} insideRefs={[]}>
      <div className={styles['container']}>
        <FilterButton
          label={label}
          onClick={toggleVisibility}
          isActive={isDropdownVisible}
          isPlaceholderLabel={isPlaceholderLabel}
        />
        <div className={cn(styles['dropdown-wrapper'], { [styles['hidden']]: !isDropdownVisible })}>
          <DropdownView
            onCheckboxChange={onCheckboxChange}
            checkboxValues={checkboxValues}
            checkboxGroups={checkboxGroups}
          />
        </div>
      </div>
    </Outside>
  );
});
